<!----------------------------------------------------------Select Categories to Import --------------------------------------------------------->

<!--Header-->
<div class="modal-header">
  <h6 class="modal-title pull-left">
    <h4>Select Categories To Import</h4>
  </h6>
  <button
    type="button"
    class="btn-close float-right"
    data-bs-dismiss="modal"
    aria-label="Close"
    (click)="closeModalClick()"
  ></button>
</div>
<hr class="divider" />
<!--body-->
<div class="row sticky-row" style="width: 90%; margin-left: 20px;">
  <div class="col-9" style="font-weight: bold;">
    <span style="margin-left:200px">Category</span>
  </div>
  <div class="col-3" style="font-weight: bold;">
    <span>Item Count</span>
  </div>
</div>
<div class="modal-body custom-modal-body">

  @for (category of accountingService.category_list; track category; let i = $index) {
    <div class="row my-1">
      <label
        for="active"
        class="col-sm-8 col-form-label col-form-label text-end"
        [ngClass]="{ 'bold-category': isBoldCategory(category['category']) }"
        >
        {{ category['category'] }}:
      </label>
      <div class="col-sm-4">
        <div class="form-check" style="margin-top: 8px">
          <input
            class="form-check-input"
            type="checkbox"
            value=""
            id="{{ category['category'] }}"
            (click)="toggleCategory($event)"
            />
            <span style="margin-left:20px">{{ category['count'] }}</span>
          </div>
        </div>
      </div>
    }
    <br />
  </div>
  <hr/>
  <!-- Buttons -->
  <div class="row; text-center">
    <div class="col-12; text-center" style="height:30px; margin-bottom:15px;">
      <button
        type="button"
        class="btn btn-success float-start"
        style="margin-left: 5px; margin-right: 5px; width: 320px"
        (click)="importCategories()"
        [disabled]="selected_categories.length === 0"
        >
        <span>Import Categories</span>
      </button>
      <!--Cancel-->
      <button
        type="button"
        class="btn btn-secondary float-end"
        data-dismiss="modal"
        style="margin-left: 5px; margin-right: 5px"
        (click)="closeModalClick()"
        >
        Cancel
      </button>
    </div>
  </div>
